import {
  AuthService,
  IdentityAccessValueFactory,
  PolicyService,
  PolicyType,
  provideIdentityAccessPermissions,
} from '@finverity/identity-access';

import { PayerInstrumentApprovalMakerPermissions } from './payer-instrument-approval-maker-permissions';

const PAYER_INSTRUMENT_APPROVAL_MAKER_IDENTITY_ACCESS_FACTORY: IdentityAccessValueFactory<
  PayerInstrumentApprovalMakerPermissions
> = (authService: AuthService, policyService: PolicyService) => {
  return {
    [PayerInstrumentApprovalMakerPermissions.ViewInstruments]: true, // TODO: replace for normal Policies: policyService.hasPolicies('view_documents'),
    [PayerInstrumentApprovalMakerPermissions.ViewInstrumentDetails]: policyService.hasPolicies(
      PolicyType.VIEW_INSTRUMENT_DETAILS
    ),
    [PayerInstrumentApprovalMakerPermissions.ViewInstrumentAttachments]: policyService.hasPolicies(
      PolicyType.VIEW_DOCUMENTS
    ),
    [PayerInstrumentApprovalMakerPermissions.ReviewInstruments]: policyService.hasPolicies(
      PolicyType.CONFIRM_INSTRUMENTS_PAYER_APPROVAL_MAKER
    ),
    [PayerInstrumentApprovalMakerPermissions.RejectInstruments]: policyService.hasPolicies(
      PolicyType.REJECT_INSTRUMENTS_PAYER_APPROVAL_MAKER
    ),
  };
};

export const PAYER_INSTRUMENT_APPROVAL_MAKER_IDENTITY_ACCESS_PROVIDER = provideIdentityAccessPermissions(
  PAYER_INSTRUMENT_APPROVAL_MAKER_IDENTITY_ACCESS_FACTORY
);
